import React from 'react';
import Translation from '../translation/translation';

function VehicleDetailsLightBoxHeader({ title }) {
    return (
        <div className="cross-sell-light-box__header cross-sell-light-box-header">
            <Translation
                translationKey='vehicle-details-lightbox-content-header'
                className="cross-sell-remove-light-box-header__headline"
            />
        </div>
    );
}

export { VehicleDetailsLightBoxHeader };
